import { Component, computed, ElementRef, HostListener, input, inject } from '@angular/core';
import { openCloseAnimation } from '@shared/animations';
import { cn } from '@shared/utils/classnames';
import { ClassValue } from 'clsx';

@Component({
  selector: 'app-dropdown',
  imports: [],
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.scss',
  animations: [openCloseAnimation()],
  styles: [],
})
export class DropdownComponent {
  private readonly eRef = inject(ElementRef);

  public readonly userClass = input<ClassValue>('', { alias: 'class' });
  public readonly closeOutsideClick = input<boolean>(true);
  protected readonly _computedClass = computed(() => cn(this.userClass()));
  protected _dropdownOpen = false;

  @HostListener('document:click', ['$event'])
  clickOut(event: Event) {
    if (!this.closeOutsideClick()) return;

    if (!this.eRef.nativeElement.contains(event.target)) {
      this.closeDropdown();
    }
  }

  toggleDropdown() {
    this._dropdownOpen = !this._dropdownOpen;
  }

  closeDropdown() {
    this._dropdownOpen = false;
  }
}
